import ClickToCopy from "./ClickToCopy";

export default ClickToCopy;

export { ClickToCopy };
